const formatPrice = (price, currency = 'INR') => {
  return (price || 0).toLocaleString('en-In', {
    style: 'currency',
    currency: currency === 'INR' ? 'INR' : 'AED',
    minimumFractionDigits: 0,
  });
};

export const numberWithCommas = num => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export default formatPrice;
